import React, { FC, ReactElement } from 'react';
import MapPolyline from 'js/components/MapObjects/MapPolyline';
import MapMarker from 'js/components/MapObjects/MapMarker';
import polygonSvg from 'style/images/drawing/polygon-marker.svg';

interface MeasurementMarker {
  position: google.maps.LatLngLiteral;
}

interface MeasurementLinesProps {
  map: google.maps.Map;
  measurementMarkers: MeasurementMarker[];
  updateMeasurementMarkers: (
    index: number,
    latLng1: google.maps.LatLngLiteral,
    latLng2: google.maps.LatLngLiteral
  ) => void;
  setSelectedMeasurementLine: (index: number | null) => void;
  markerListenerInstance?: object | null;
}

const MeasurementLines: FC<MeasurementLinesProps> = ({
  map,
  measurementMarkers,
  updateMeasurementMarkers,
  setSelectedMeasurementLine,
  markerListenerInstance,
}) => {
  const polylines: ReactElement[] = [];
  const singleMarkers: ReactElement[] = [];

  const iconOptions: google.maps.Icon = {
    url: polygonSvg,
    scaledSize: new google.maps.Size(20, 20),
    anchor: new google.maps.Point(10, 10), // centers icon
  };

  for (let i = 0; i < measurementMarkers.length; i += 2) {
    const marker1 = measurementMarkers[i];
    const marker2 = measurementMarkers[i + 1];

    if (marker1?.position) {
      if (marker2?.position) {
        polylines.push(
          <MapPolyline
            key={`polyline-${i}`}
            map={map}
            marker1={marker1}
            marker2={marker2}
            editable={markerListenerInstance == null}
            onChange={({
              latLng1,
              latLng2,
            }: {
              latLng1: google.maps.LatLngLiteral;
              latLng2: google.maps.LatLngLiteral;
            }) => updateMeasurementMarkers(i, latLng1, latLng2)}
            index={i}
            setSelectedPolyline={setSelectedMeasurementLine}
          />
        );
      } else {
        singleMarkers.push(
          <MapMarker key={`marker-${i}`} position={marker1.position} icon={iconOptions} />
        );
      }
    }
  }

  return <>{[...polylines, ...singleMarkers]}</>;
};

export default MeasurementLines;
